import { t } from '@lingui/core/macro';
import { useMemo } from 'react';

import {
  encodeFilterFieldName,
  FilterField,
  SelectPickerFilter,
  useFilterForm,
} from '@/components/filters';
import type { FilterOperatorMulti } from '@/components/InstantSearch';
import type { FilterComponentProps } from '@/providers/TableState';

type Props = FilterComponentProps;

const InTamFilter = ({ name, label, infoPopover, compact = false }: Props) => {
  const form = useFilterForm();
  const options = useMemo(
    () => [
      {
        id: 'true',
        name: t`In TAM`,
      },
      {
        id: 'false',
        name: t`Not In TAM`,
      },
    ],
    [],
  );
  return (
    <form.AppField name={encodeFilterFieldName(name)}>
      {(field) => (
        <FilterField
          data-testid="in-tam-filter"
          label={label}
          infoPopover={infoPopover}
          hideLabel={!compact}
        >
          <SelectPickerFilter
            value={field.state.value as FilterOperatorMulti}
            onChange={field.handleChange}
            options={options}
            placeholder={t`Select option...`}
            notFoundContent={t`No options were found...`}
          />
        </FilterField>
      )}
    </form.AppField>
  );
};

export default InTamFilter;
